import { getCookie } from '../../common/utils/cookies';
import { AccessibilityFeatures, Task } from './../interfaces/taskTile';
import { getExperienceInitCookie } from './../../common/utils/experienceInitCookie';
import { getStore } from '../../store';
const tcPlusFlow = getCookie('TcPlusFlag') === '1';
const expCookie = getExperienceInitCookie();

export const getAccessibilityFeaturesForTask = (task: Task): AccessibilityFeatures => {
  const showAccessibilityforTcCompany = !tcPlusFlow && expCookie && expCookie.accessibilityStatementEnabled;
  const showAccessibilityforTcPlusCompany =
    tcPlusFlow && getStore()?.state.companySettings?.accessibilityStatementEnabled;

  const isAccessibilityStatementEnabled = showAccessibilityforTcCompany || showAccessibilityforTcPlusCompany;

  if (!isAccessibilityStatementEnabled) return {} as AccessibilityFeatures;

  return task.items.reduce((acc, taskItem) => {
    const accessibilityFeatures = taskItem.accessibilityFeatures;
    if (accessibilityFeatures) {
      (Object.keys(accessibilityFeatures) as (keyof AccessibilityFeatures)[]).forEach(
        (accessibilityItem: keyof AccessibilityFeatures) => {
          if (!accessibilityFeatures[accessibilityItem]) {
            acc[accessibilityItem] = false;
          }
        },
      );
      return acc;
    }

    return acc;
  }, {} as AccessibilityFeatures);
};
